import React, { useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import styled from 'styled-components';
import { CTA } from "../../../../../general/Button";
import config from "../../../../../../config/channels";
import useOperatorContext from "../../../../../../contexts/operator/useOperatorContext";
import useSiteContext from "../../../../../../contexts/site/useSiteContext";
import TinyModal from "../../../../../general/TinyModal";

type AllergensModalProps = {
    show: boolean;
    allergens: string;
    onHide: () => void;
};

const AllergensModal = ({
    show,
    allergens,
    onHide,
}: AllergensModalProps) => {

    const operatorContext = useOperatorContext();
    const siteContext = useSiteContext();
    const isDineIn = siteContext.channel === config.dineIn.name;

    useEffect(() => {
        document.getElementById('allergens-modal')?.classList.add('anim-enter');

        return () => {
            document.getElementById('allergens-modal')?.classList.remove('anim-enter');
        };
    }, [show]);

    const renderFooter = () => (
        <>
            <CTA block
                 onClick={onHide}>
                <span>Continue</span>
            </CTA>
        </>
    );

    return (
        <TinyModal
            show={show}
            onHide={onHide}
            backdropClassName="modal-item-allergens-backdrop"
            className="item-allergens-modal-dialog"
            header="Allergen info"
            footer={renderFooter()}
            modalID={'allergens-modal'}
        >
           <>
               {allergens && (
                   <p>{ allergens }</p>
               )}
               <p dangerouslySetInnerHTML={{ __html: isDineIn ? (operatorContext.operator?.theme.v4.allergen_info_onsite ?? '') : (operatorContext.operator?.theme.v4.allergen_info ?? '') }}></p>
           </>
        </TinyModal>
    );
};

export default AllergensModal;
